export default __webpack_public_path__ + "static/media/mlodz2.1e1cc039.jpg";